import React from 'react'

import {noop} from 'es-toolkit'

import './tab.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props<T> = Overwrite<
  CommonProps<'button'>,
  {
    label: React.ReactNode
    tabKey: T
    icon?: React.ReactNode
    active?: boolean
    disabled?: boolean
    onClick?: (tabKey: T) => void
  }
>

const Tab = <T,>({
  className,
  label,
  tabKey,
  icon,
  active = false,
  disabled = false,
  onClick = noop,
  ...props
}: Props<T>) => (
  <button
    {...props}
    className={cn('Tab', {active, disabled}, className)}
    type="button"
    onClick={() => onClick(tabKey)}
    disabled={disabled}
  >
    {icon && <span className="Tab__icon">{icon}</span>}
    <span className="Tab__label">{label}</span>
  </button>
)

export default Tab
